import { inRange } from "lodash";
import moment from "moment";
import AppContext from "PFApp/app_context";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { Threshold } from "PFTypes";
import { useContext } from "react";

import { Overbooking } from "../../../../../types";

const numberToPercent = (value: number) => value * 100;

export type OverbookingWithThreshold = {
  overbookings: Overbooking[];
  threshold: Threshold | undefined;
};

type UseGroupItemsByThreshold = {
  groupItemsByThreshold: (overbookings: Overbooking[]) => OverbookingWithThreshold[];
};

export const useGroupItemsByThreshold = (): UseGroupItemsByThreshold => {
  const {
    store: {
      currentAccount: { thresholds }
    }
  } = useContext(AppContext);
  const { formatISODate } = useDateFormatter();

  const overbookingThresholds = thresholds.filter(({ kind }) => kind === "overbooking");
  const groupItemsByThreshold = (overbookings: Overbooking[] = []) =>
    overbookings.reduce<OverbookingWithThreshold[]>((groupedItems, current, index) => {
      const currentDate = current.date;
      const previousDate = overbookings[index - 1]?.date;
      const areDaysAfterEachOther = previousDate
        ? formatISODate(moment(previousDate).add(1, "day")) === currentDate
        : true;

      const currentOverbookingThreshold = overbookingThresholds.find(({ min, max }) =>
        inRange(numberToPercent(current.utilization), min, max + 1)
      );
      const previousOverbookingThreshold = overbookingThresholds.find(({ min, max }) =>
        inRange(numberToPercent(overbookings[index - 1]?.utilization), min, max + 1)
      );
      if (
        currentOverbookingThreshold?.color === previousOverbookingThreshold?.color &&
        areDaysAfterEachOther
      ) {
        groupedItems[groupedItems.length - 1] = {
          overbookings: [...(groupedItems[groupedItems.length - 1]?.overbookings ?? []), current],
          threshold: currentOverbookingThreshold
        };
      } else {
        groupedItems.push({
          overbookings: [current],
          threshold: currentOverbookingThreshold
        });
      }
      return groupedItems;
    }, []);
  return { groupItemsByThreshold };
};
